import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const taskVuex = createNamespacedHelpers("task");
const walletVuex = createNamespacedHelpers("wallet");
import vailcode from "@utils/errcode";
import { address, toNano } from "@ton/core";
export default {
  name: "botcode",
  computed: {
    ...userVuex.mapState(["isLogin", "rewards", "userInfo", "settingInfo"]),
    ...taskVuex.mapState(["taskInfo", "timerObjs"]),
    ...walletVuex.mapState(["tonConnect"])
  },
  data() {
    return {
      gameInfo: null,
      gameBalance: {
        amount: 0,
        recovery: {
          count: 0,
          countdown: 0
        }
      },
      gameOption: null,
      gameLogs: null,
      selectOption: null,
      rowIndex: 0,
      gameSize: 0,
      popRestartShow: false,
      isRestartLoading: false,
      popBuyAmountShow: false,
      buyAmountList: [],
      buyAmountListLoading: false,
      payRestartType: "Stars",
      payType: "Stars",
      isPayRestartLoading: false,
      isMovesAnim: false,
      rowStorePrice: null,
      popSelectPaymentShow: false,
      rankList: null,
      popPayRecordShow: false,
      inviteRecordList: null,
      inviteRecordPage: {
        page: 1,
        limit: 50,
        isLoading: false,
        totalPages: 1
      },
      popGameRewardShow: false,
      isGameCheckLoading: false,
      isRestartPayCheck: false,
      isRestartPayCheckLoading: false,
      restartPaymentId: null,
      gameRewardInfo: null,
      isErrorAnim: false,
      isBotcodeGameInfoShow: false,
      calcBalanceTimer: 0,
      isRefreshBtnOption: true,
      popNoEnoughMovesShow: false,
      popGameRuleShow: false
    };
  },
  watch: {
    isLogin: {
      async handler(bool) {
        if (bool) {
          this.initFnc();
        }
      },
      deep: true,
      immediate: true
    },
    "gameInfo.step": {
      handler(newVal, oldVal) {
        if ((newVal !== "undefined " || newVal !== "null") && newVal != oldVal) {
          this.isRefreshBtnOption = false;
          setTimeout(() => {
            this.isRefreshBtnOption = true;
          }, 200);
        }
      },
      deep: true,
      immediate: true
    },
    "gameBalance.amount": {
      handler(newVal, oldVal) {
        if (newVal >= 0) {
          this.popNoEnoughMovesShow = false;
        }
      },
      deep: true,
      immediate: true
    },
    "taskInfo.popReward.isEnd": {
      async handler(bool) {
        if (!bool) return;
        this.setIsBotcodeGameInfoShow();
      },
      deep: true
    }
  },
  methods: {
    ...userVuex.mapActions(["getBalanceInfo"]),
    ...userVuex.mapMutations(["setUserInfo"]),
    ...taskVuex.mapActions(["openInvoiceStarPay"]),
    onSkipBanner() {
      this.WebApp.openLink("https://docs.google.com/spreadsheets/d/1uEzvKqNmVQTGMwDNxhEZXPURLlSWtJiX/edit?usp=sharing&ouid=111003245911414474074&rtpof=true&sd=true");
    },
    setConfetti() {
      this.confetti({
        particleCount: 15,
        angle: 60,
        spread: 55,
        origin: {
          x: 0
        },
        zIndex: 2000,
        colors: ["9cfd09", "3edf46", "0ccf66", "39580e", "a0fe07"]
      });
      this.confetti({
        particleCount: 15,
        angle: 120,
        spread: 55,
        origin: {
          x: 1
        },
        zIndex: 2000,
        colors: ["9cfd09", "3edf46", "0ccf66", "39580e", "a0fe07"]
      });
    },
    onShare() {
      this.hapticFeedback();
      this.WebApp.openTelegramLink(`https://t.me/share/url?text=Who%20let%20the%20${this.settingInfo.coin}%20out%20&url=https://t.me/${this.settingInfo.botname}/app?startapp=ref_${this.userInfo.ref_code}`);
    },
    onCopy() {
      this.hapticFeedback();
      const that = this;
      this.$copyText(`https://t.me/${this.settingInfo.botname}/app?startapp=ref_${this.userInfo.ref_code}`).then(function (e) {
        that.$toasted.clear();
        that.$toasted.success(that.$lang("Copy Success!"));
      }, function (e) {});
    },
    calcMovesRecoveryTime() {
      // this.gameBalance = {
      //   amount: 0,
      //   recovery: {
      //     count: 0,
      //     countdown: 10000,
      //   },
      // };
      const balance = this.gameBalance;
      const recovery = balance.recovery;
      clearTimeout(this.timerObjs.botcodePage.movesRecoveryTimer);
      const calcFnc = async () => {
        recovery.countdown--;
        // console.log("recovery.countdown", recovery.countdown);
        if (recovery.countdown <= 0 && this.calcBalanceTimer <= 5) {
          this.calcBalanceTimer++;
          clearTimeout(this.timerObjs.botcodePage.movesRecoveryTimer);
          setTimeout(() => {
            this.initFnc();
          }, 2000);
          return;
        }
        if (recovery.countdown > 0) {
          this.calcBalanceTimer = 0;
          this.timerObjs.botcodePage.movesRecoveryTimer = setTimeout(calcFnc, 2000);
        }
      };
      calcFnc();
    },
    async initFnc() {
      this.gameInfo = null;
      this.gameOption = null;
      await this.setGameConfig();
      await this.getRankList();
    },
    setGameData(data) {
      this.gameBalance = data.balance;
      this.calcMovesRecoveryTime();
      this.selectOption = Array.from({
        length: data.game.size
      }, () => null);
      this.gameInfo = {
        ...data.game,
        logs: data.game.logs.map(it => {
          return {
            ...it,
            isAnim: true
          };
        })
      };
      this.gameSize = data.size;
      this.gameOption = data.game.options.map(item => {
        return {
          ...item,
          disable: false
        };
      }).slice(0, data.game.size);
      this.rowIndex = 0;
    },
    setGameConfig() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/game/cipher/info", {});
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          this.setGameData(data);
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    async checkGameResult() {
      return new Promise(async resolve => {
        const fnc = async (_params, errNum) => {
          const params = {
            date: _params ? _params.today : this.gameInfo.date,
            step: _params ? _params.step : this.gameInfo.step,
            answer: JSON.stringify(this.selectOption.map(it => {
              return it.id;
            }))
          };
          console.log("paramsparamsparams", params);
          const res = await _v.$http.post("/game/cipher/check", params);
          if (!res) {
            this.$toasted.error("Network Error, please try again!");
            // resolve();
            this.gameOption.map(item => {
              item.disable = false;
            });
            this.selectOption = Array.from({
              length: this.gameInfo.size
            }, () => null);
            this.rowIndex = 0;
            this.isGameCheckLoading = false;
            return;
          }
          if (res && res.code > 0) {
            if (res.data && !errNum) {
              await fnc(res.data, 1);
              return;
            }
            this.$toasted.error(res.message);
            resolve();
            return;
          }
          const _data = res.data;
          if (!_data) {
            resolve();
            return;
          }
          let data = _data.info;
          if (_data.success) {
            this.setGameData(data);
            this.setConfetti();
            this.taskInfo.popReward.reward = _data.rewards;
            this.taskInfo.popReward.icon = "MORE";
            this.taskInfo.popReward.userInfo = {
              ...this.userInfo,
              airdrop_ticket: this.userInfo.airdrop_ticket + _data.rewards.ticket,
              coin: this.userInfo.coin + _data.rewards.coin
            };
            this.taskInfo.popReward.show = true;
            this.isGameCheckLoading = false;
            this.$httpClear("/game/cipher/ranking");
            await this.getRankList();
            resolve(data);
            return;
          }
          this.isErrorAnim = false;
          this.gameBalance = data.balance;
          this.calcMovesRecoveryTime();
          this.selectOption = Array.from({
            length: data.game.size
          }, () => null);
          this.gameInfo = {
            ...data.game,
            logs: this.gameInfo.logs.map(it => {
              return {
                ...it,
                isAnim: true
              };
            })
          };
          this.gameSize = data.size;
          this.gameOption = data.game.options.map(item => {
            return {
              ...item,
              disable: false
            };
          }).slice(0, data.game.size);
          this.rowIndex = 0;
          const results = [];
          results.push(..._data.results);
          this.gameInfo.logs.push({
            id: new Date().getTime(),
            success: 0,
            results,
            isAnim: false
          });
          await new Promise(resolve => setTimeout(resolve, 200));
          this.setStockFloatNumber(1, "-");
          this.gameInfo.logs[this.gameInfo.logs.length - 1].isAnim = true;
          await new Promise(resolve => setTimeout(resolve, 1500));
          this.isErrorAnim = true;
          this.isGameCheckLoading = false;
          await new Promise(resolve => setTimeout(resolve, 3000));
          this.isErrorAnim = false;
          resolve(_data);
        };
        fnc();
      });
    },
    async getBuyAmountList() {
      return new Promise(async resolve => {
        const res = await this.$http.post("/game/cipher/prices", {});
        vailcode(res, () => {
          const data = res.data.map(item => {
            return {
              ...item,
              isLoading: false
            };
          });
          if (!data) {
            resolve();
            return;
          }
          const firstItem = data[0];
          console.log("firstItem", firstItem);
          this.buyAmountList = data.map((item, index) => {
            return {
              ...item,
              off: index == 0 ? null : this.fmt_pre((1 - firstItem.count / firstItem.stars / (item.count / item.stars)) * 100, 2)
            };
          });
          console.log("this.buyAmountList", this.buyAmountList);
          resolve(data);
        }, () => resolve());
      });
    },
    async payBuyAmount(params) {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/game/cipher/reset", params);
        vailcode(res, () => {
          resolve(res);
        }, () => {
          resolve();
        });
      });
    },
    async getRankList() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/game/cipher/ranking", {});
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          this.rankList = data;
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    async onSelect(item, index, type) {
      // this.gameRewardInfo = {
      //   coin: 500,
      //   ticket: 50,
      //   giftshard: {
      //     10: {
      //       type: 0,
      //       name: "",
      //       thumb: "https://static.humanpass.net/202507/24/file_8.webp",
      //       image: "https://static.tapcoins.app/202507/15/file_34.webp",
      //       amount: 1,
      //     },
      //   },
      // };
      // this.taskInfo.popReward.reward = this.gameRewardInfo;
      // this.taskInfo.popReward.icon = "MORE";
      // // this.taskInfo.popReward.userInfo =null;
      // this.taskInfo.popReward.show = true;
      // return;
      if (!item) return;
      console.log("this.gameBalance.amount", this.gameBalance.amount);
      if (this.gameBalance.amount <= 0) {
        this.$toasted.clear();
        this.$toasted.info("Not enough moves");
        setTimeout(() => {
          this.popNoEnoughMovesShow = true;
        }, 500);
        return;
      }
      if (type == 1) {
        this.selectOption.splice(this.rowIndex, 1, item);
        console.log("item, index, type", item, index, type, this.selectOption);
        this.rowIndex = this.selectOption.findIndex(itm => !itm);
        item.disable = true;
      } else if (type == 0) {
        this.gameOption.map((itm, idx) => {
          if (itm.id == item.id) {
            itm.disable = false;
            this.selectOption.splice(index, 1, null);
            this.rowIndex = this.selectOption.findIndex(itm => !itm);
          }
        });
      }
      const bool = this.selectOption.every(it => it);
      if (!bool) return;
      if (this.isGameCheckLoading) return;
      this.isGameCheckLoading = true;
      const res = await this.checkGameResult();
      if (!res) {
        this.isGameCheckLoading = false;
        this.initFnc();
        return;
      }
    },
    async onRestart() {
      this.popRestartShow = true;
    },
    async onBuyAmount() {
      this.popBuyAmountShow = true;
      await this.getBuyAmountList();
    },
    onRestartSelectPay(type) {
      this.payRestartType = type;
    },
    onPayRestart() {
      const fnc = async () => {
        let params = {
          currency: this.payRestartType
        };
        if (this.payRestartType === "Ton") {
          params["address"] = this.tonWallet.uiAddress;
        }
        if (this.isPayRestartLoading) return;
        this.isPayRestartLoading = true;
        const res = await this.payBuyAmount(params);
        if (!res) {
          this.isPayRestartLoading = false;
          return;
        }
        let data = res.data;
        console.log("data11111111", data);
        if (this.payRestartType === "Ton" && data?.chainInfo) {
          let msg = [{
            address: data.chainInfo.contract,
            amount: toNano(data.chainInfo.amount).toString(),
            payload: data.chainInfo.raw
          }];
          this.isRestartPayCheck = true;
          const payRef = await this.tonWallet.sendTransaction(msg);
          if (!payRef) {
            this.isRestartPayCheck = false;
            this.isPayRestartLoading = false;
            return;
          }
          this.restartPaymentId = data.paymentId;
          const upRes = await this.poolRestartPay(data, 6);
          console.log("upResupRes123", upRes);
          if (!upRes) return;
          this.popRestartShow = false;
          this.setGameData(upRes.data.info);
          this.isPayRestartLoading = false;
          this.isRestartPayCheck = false;
          this.restartPaymentId = null;
          this.setIsBotcodeGameInfoShow();
          await this.getBalanceInfo(false);
          this.$httpClear("/game/cipher/ranking");
          await this.getRankList();
        } else if (this.payRestartType == "Stars" && data?.chainInfo) {
          const payRef = await this.openInvoiceStarPay({
            url: data.chainInfo.payment_url
          });
          if (!payRef) {
            this.isRestartPayCheck = false;
            this.isPayRestartLoading = false;
            return;
          }
          this.restartPaymentId = data.paymentId;
          this.isRestartPayCheck = true;
          const upRes = await this.poolRestartPay(data, 3);
          console.log("upResupResupResupRes456", upRes);
          if (!upRes) return;
          this.setGameData(upRes.data.info);
          this.popRestartShow = false;
          this.isPayRestartLoading = false;
          this.isRestartPayCheck = false;
          this.restartPaymentId = null;
          this.setIsBotcodeGameInfoShow();
          await this.getBalanceInfo(false);
          this.$httpClear("/game/cipher/ranking");
          await this.getRankList();
        } else {
          console.log("6666123123", data);
          this.setGameData(data.info);
          this.popRestartShow = false;
          this.isPayRestartLoading = false;
          this.isRestartPayCheck = false;
          this.setIsBotcodeGameInfoShow();
          await this.getBalanceInfo(false);
          this.$httpClear("/game/cipher/ranking");
          await this.getRankList();
          return;
        }
      };
      clearInterval(this.timerObjs.botcodePage.restartTonConnectTimer);
      if (this.payRestartType === "Ton" && !this.tonConnect) {
        this.tonWallet.connectTon();
        this.timerObjs.botcodePage.restartTonConnectTimer = setInterval(async () => {
          console.log("this.tonConnectthis.tonConnect", this.tonConnect);
          if (this.tonConnect) {
            clearInterval(this.timerObjs.botcodePage.restartTonConnectTimer);
            fnc();
          }
        }, 1000);
      } else {
        fnc();
      }
    },
    async poolRestartPay(resp, timer = 3) {
      return new Promise(async resolve => {
        const fnc = async resp => {
          this.timerObjs.botcodePage.restartPayTimer = setTimeout(async () => {
            let params = {
              currency: this.payType,
              address: this.tonWallet.uiAddress,
              paymentId: this.restartPaymentId
            };
            const res = await this.payBuyAmount(params);
            if (!res) {
              this.$toasted.error("Network Error, please try again!");
              clearTimeout(this.timerObjs.botcodePage.restartPayTimer);
              this.isPayRestartLoading = false;
              resolve();
            } else if (res.code == 302) {
              clearTimeout(this.botcodePage.restartPayTimer);
              await fnc(resp);
            } else if (res.code > 0) {
              this.isPayRestartLoading = false;
              clearTimeout(this.timerObjs.botcodePage.restartPayTimer);
              this.$toasted.error(res.message);
              resolve();
            } else {
              clearTimeout(this.timerObjs.botcodePage.restartPayTimer);
              this.isPayRestartLoading = false;
              resolve(res);
            }
          }, timer * 1000);
        };
        await fnc(resp);
      });
    },
    async onRestartPayCheck() {
      if (!this.restartPaymentId) return;
      let params = {
        currency: this.payType,
        address: this.tonWallet.uiAddress,
        paymentId: this.restartPaymentId
      };
      console.log("paramsparamsparamsparams", params);
      if (this.isRestartPayCheckLoading) return;
      this.isRestartPayCheckLoading = true;
      const res = await this.payBuyAmount(params);
      if (!res) {
        this.isRestartPayCheckLoading = false;
        this.$toasted.error("Network Error, please try again!");
      } else if (res.code == 302) {
        this.$toasted.error(res.message);
        this.isRestartPayCheckLoading = false;
      } else if (res.code > 0) {
        this.$toasted.error(res.message);
        this.isRestartPayCheckLoading = false;
      } else {
        clearTimeout(this.timerObjs.botcodePage.restartPayTimer);
        let data = res.data;
        this.setGameData(data.info);
        this.popRestartShow = false;
        this.isPayRestartLoading = false;
        await this.getBalanceInfo(false);
        this.isRestartPayCheckLoading = false;
        this.setStockFloatNumber(data.info.game.reset.countPerDay, "+");
        this.setIsMovesAnim();
      }
    },
    selectStorePrice(item, index) {
      if (item.isLoading) {
        this.popSelectPaymentShow = true;
        return;
      }
      this.rowStorePrice = {
        ...item,
        index,
        isLoading: false,
        paymentId: null,
        isBtnCheck: false,
        isBtnCheckLoading: false
      };
      console.log("item, index", item, index, this.rowStorePrice);
      this.popSelectPaymentShow = true;
    },
    onSelectPay(type) {
      this.payType = type;
    },
    payAmount(params) {
      return new Promise(async resolve => {
        const res = await this.$http.post("/game/cipher/buy", params);
        resolve(res);
      });
    },
    onPayAmount() {
      const fnc = async () => {
        let params = {
          index: this.rowStorePrice.index,
          currency: this.payType
        };
        if (this.payType === "Ton") {
          params["address"] = this.tonWallet.uiAddress;
        }
        if (this.rowStorePrice.isLoading) return;
        this.buyAmountList[this.rowStorePrice.index].isLoading = this.rowStorePrice.isLoading = true;
        const res = await this.payAmount(params);
        if (!res) {
          this.buyAmountList[this.rowStorePrice.index].isLoading = this.rowStorePrice.isLoading = false;
          return;
        }
        let data = res.data;
        if (this.payType === "Ton" && data?.chainInfo) {
          let msg = [{
            address: data.chainInfo.contract,
            amount: toNano(data.chainInfo.amount).toString(),
            payload: data.chainInfo.raw
          }];
          const payRef = await this.tonWallet.sendTransaction(msg);
          if (!payRef) {
            this.buyAmountList[this.rowStorePrice.index].isLoading = this.rowStorePrice.isLoading = false;
            return;
          }
          this.buyAmountList[this.rowStorePrice.index].isBtnCheck = this.rowStorePrice.isBtnCheck = true;
          this.buyAmountList[this.rowStorePrice.index].paymentId = data.paymentId;
          const upRes = await this.poolPayUpgradeStore(data, 6);
          if (!upRes) {
            this.buyAmountList[this.rowStorePrice.index].isLoading = this.rowStorePrice.isLoading = false;
            this.buyAmountList[this.rowStorePrice.index].isBtnCheck = this.rowStorePrice.isBtnCheck = false;
            return;
          }
          this.gameBalance = upRes.data;
          this.calcMovesRecoveryTime();
          this.popSelectPaymentShow = false;
          this.popBuyAmountShow = false;
          await this.getBalanceInfo(false);
          this.setStockFloatNumber(this.buyAmountList[this.rowStorePrice.index].count, "+");
          this.setIsMovesAnim();
        } else if (this.payType == "Stars" && data?.chainInfo) {
          const payRef = await this.openInvoiceStarPay({
            url: data.chainInfo.payment_url
          });
          if (!payRef) {
            this.buyAmountList[this.rowStorePrice.index].isBtnCheck = this.rowStorePrice.isBtnCheck = false;
            this.buyAmountList[this.rowStorePrice.index].isLoading = this.rowStorePrice.isLoading = false;
            return;
          }
          this.buyAmountList[this.rowStorePrice.index].isBtnCheck = this.rowStorePrice.isBtnCheck = true;
          this.buyAmountList[this.rowStorePrice.index].paymentId = data.paymentId;
          const upRes = await this.poolPayUpgradeStore(data, 3);
          console.log("upResupResupResupRes", upRes);
          if (!upRes) {
            this.buyAmountList[this.rowStorePrice.index].isLoading = this.rowStorePrice.isLoading = false;
            this.buyAmountList[this.rowStorePrice.index].isBtnCheck = this.rowStorePrice.isBtnCheck = false;
            return;
          }
          this.gameBalance = upRes.data;
          this.calcMovesRecoveryTime();
          this.popSelectPaymentShow = false;
          this.popBuyAmountShow = false;
          await this.getBalanceInfo(false);
          this.setStockFloatNumber(this.buyAmountList[this.rowStorePrice.index].count, "+");
          this.setIsMovesAnim();
        } else {
          this.buyAmountList[this.rowStorePrice.index].isLoading = this.rowStorePrice.isLoading = false;
          this.gameBalance = data;
          this.calcMovesRecoveryTime();
          this.popSelectPaymentShow = false;
          this.popBuyAmountShow = false;
          await this.getBalanceInfo(false);
          this.setStockFloatNumber(this.buyAmountList[this.rowStorePrice.index].count, "+");
          this.setIsMovesAnim();
        }
      };
      clearInterval(this.timerObjs.botcodePage.restartTonConnectTimer);
      if (this.payType === "Ton" && !this.tonConnect) {
        this.tonWallet.connectTon();
        this.timerObjs.botcodePage.restartTonConnectTimer = setInterval(async () => {
          if (this.tonConnect) {
            clearInterval(this.timerObjs.botcodePage.restartTonConnectTimer);
            fnc();
          }
        }, 1000);
      } else {
        fnc();
      }
    },
    async poolPayUpgradeStore(resp, timer) {
      return new Promise(async resolve => {
        const rowStorePrice = this.rowStorePrice;
        const fnc = async resp => {
          this.timerObjs.botcodePage.amountPayTimer = setTimeout(async () => {
            let params = {
              index: rowStorePrice.index,
              currency: this.payType,
              address: this.tonWallet.uiAddress,
              paymentId: resp.paymentId
            };
            const res = await this.payAmount(params);
            if (!res) {
              this.$toasted.error("Network Error, please try again!");
              this.buyAmountList[this.rowStorePrice.index].isLoading = this.rowStorePrice.isLoading = false;
              resolve();
            } else if (res.code == 302) {
              clearTimeout(this.timerObjs.botcodePage.amountPayTimer);
              await fnc(resp);
            } else if (res.code > 0) {
              this.buyAmountList[this.rowStorePrice.index].isLoading = this.rowStorePrice.isLoading = false;
              clearTimeout(this.timerObjs.botcodePage.amountPayTimer);
              this.$toasted.error(res.message);
              resolve();
            } else {
              clearTimeout(this.timerObjs.botcodePage.amountPayTimer);
              this.buyAmountList[this.rowStorePrice.index].isLoading = this.rowStorePrice.isLoading = false;
              this.buyAmountList[this.rowStorePrice.index].isBtnCheck = this.rowStorePrice.isBtnCheck = false;
              resolve(res);
            }
          }, timer * 1000);
        };
        await fnc(resp);
      });
    },
    async onPayAmountCheck() {
      let params = {
        index: rowStorePrice.index,
        currency: this.payType,
        address: this.tonWallet.uiAddress,
        paymentId: this.buyAmountList[this.rowStorePrice.index].paymentId
      };
      const res = await this.payAmount(params);
      if (!res) {
        this.$toasted.error("Network Error, please try again!");
        this.buyAmountList[this.rowStorePrice.index].isBtnCheckLoading = this.rowStorePrice.isBtnCheckLoading = false;
      } else if (res.code == 302) {
        this.buyAmountList[this.rowStorePrice.index].isBtnCheckLoading = this.rowStorePrice.isBtnCheckLoading = false;
        this.$toasted.error(res.message);
      } else if (res.code > 0) {
        this.buyAmountList[this.rowStorePrice.index].isBtnCheckLoading = this.rowStorePrice.isBtnCheckLoading = false;
        this.$toasted.error(res.message);
      } else {
        clearTimeout(this.timerObjs.botcodePage.amountPayTimer);
        this.buyAmountList[this.rowStorePrice.index].isBtnCheckLoading = this.rowStorePrice.isBtnCheckLoading = false;
        this.buyAmountList[this.rowStorePrice.index].isBtnCheck = this.rowStorePrice.isBtnCheck = false;
        this.gameBalance = data;
        this.calcMovesRecoveryTime();
        this.popSelectPaymentShow = false;
        this.popBuyAmountShow = false;
        await this.getBalanceInfo(false);
        this.setStockFloatNumber(this.buyAmountList[this.rowStorePrice.index].count, "+");
        this.setIsMovesAnim();
      }
    },
    onRecord() {
      this.popPayRecordShow = true;
      this.inviteRecordAddEventListenerScroll();
    },
    async getInviteRecordList(page = 1, limit = 10) {
      this.inviteRecordPage.isLoading = true;

      // // 模拟后端总数据
      // const allItems = Array.from({ length: 35 }, (_, i) => ({
      //   id: i + 1,
      //   firstname: "User",
      //   lastname: `#${i + 1}`,
      //   head_color: "#cf5fa7",
      //   avatar_url: null,
      //   rewards: { cipher: 30 + i },
      //   created_at: new Date().toISOString(),
      // }));

      // const total = allItems.length;
      // const start = (page - 1) * limit;
      // const end = page * limit;
      // const paginatedItems = allItems.slice(start, end);

      // const res = {
      //   code: 0,
      //   message: "",
      //   data: {
      //     total,
      //     perPage: limit,
      //     lastPage: Math.ceil(total / limit),
      //     currentPage: page,
      //     items: paginatedItems,
      //   },
      // };

      const res = await _v.$http.post("/game/cipher/invitation/logs", {
        page,
        limit
      });
      return new Promise(resolve => {
        vailcode(res, () => {
          const items = res.data.items || [];
          if (page === 1) {
            this.inviteRecordList = items;
          } else {
            this.inviteRecordList.push(...items);
          }
          this.inviteRecordPage.totalPages = res.data.lastPage;
          this.inviteRecordPage.page = page;
          this.inviteRecordPage.isLoading = false;
          resolve(items);
        }, () => {
          this.inviteRecordPage.isLoading = false;
          resolve([]);
        });
      });
    },
    async inviteRecordHandleScroll(e) {
      const el = e.target;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10 && !this.inviteRecordPage.isLoading && this.inviteRecordPage.page < this.inviteRecordPage.totalPages) {
        this.$httpClear("/game/cipher/invitation/logs");
        this.getInviteRecordList(this.inviteRecordPage.page + 1, this.inviteRecordPage.limit);
      }
    },
    inviteRecordAddEventListenerScroll() {
      this.$nextTick(() => {
        const container = this.$refs.poppayrecord;
        setTimeout(() => {
          this.getInviteRecordList(1, this.inviteRecordPage.limit);
          if (container) {
            container.onscroll = this.inviteRecordHandleScroll;
          }
        }, 200);
      });
    },
    onPopGameRewardConfirm() {
      this.popGameRewardShow = false;
      this.setIsBotcodeGameInfoShow();
    },
    async setIsBotcodeGameInfoShow() {
      this.isBotcodeGameInfoShow = true;
      await new Promise(resolve => setTimeout(resolve, 2000));
      this.isBotcodeGameInfoShow = false;
    },
    async setIsMovesAnim() {
      await new Promise(resolve => setTimeout(resolve, 1000));
      this.isMovesAnim = true;
      await new Promise(resolve => setTimeout(resolve, 2000));
      this.isMovesAnim = false;
    }
  },
  mounted() {},
  beforeDestroy() {
    clearTimeout(this.timerObjs.botcodePage.restartPayTimer);
    clearInterval(this.timerObjs.botcodePage.restartTonConnectTimer);
    clearTimeout(this.timerObjs.botcodePage.amountPayTimer);
    clearTimeout(this.timerObjs.botcodePage.movesRecoveryTimer);
    console.log(888);
  }
};